import type { Reducer } from 'redux';

import type { PushNotificationsSaveSettingsAction } from '../../domains/pushNotifications/actions.types';

import type { PushNotificationsSettings } from './types';

export type PushNotificationsSettingsAction = PushNotificationsSaveSettingsAction;

let cachedInitialClientId: string | undefined;
const getInitialClientId = (): string => {
  cachedInitialClientId ??= crypto.randomUUID();

  return cachedInitialClientId;
};

export const createInitialState: () => PushNotificationsSettings = () => ({
  clientId: getInitialClientId(),
  enabled: false,
});

const reducer: Reducer<PushNotificationsSettings, PushNotificationsSettingsAction> = (
  state = createInitialState(),
  action
) => {
  switch (action.type) {
    case 'PUSH_NOTIFICATIONS.SAVE_SETTINGS':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default reducer;
